module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-kecpangarengan",
  subdomain: "kecpangarengan",
};
